import type React from 'react';
import { type FC, isValidElement, type PropsWithChildren } from 'react';

import type { ThemeMode } from '@/helpers/enums';
import type { ValidatorMessage } from '@/helpers/validators';
import type { RegistrationConfig } from '@/modules/registration/helpers/types';

import { ScInputStructure } from './styled';

export interface InputStructureProps extends PropsWithChildren {
  error?: React.ReactNode;
  hideInputErrorColor?: boolean;
  disabled?: boolean;
  hideErrorMessage?: boolean;
  hideErrorBorder?: boolean;
  infoMessage?: string | JSX.Element;
  addons?: JSX.Element;
  withTick?: boolean;
  mode?: ThemeMode;
  styleScheme?: RegistrationConfig['styleScheme'];
  withInsideLabel?: boolean;
  background?: string;
  setInputRightPadding?: (arg: number) => void;
  preventValidation?: boolean;
  mask?: (value: string) => void;
  validatorWarning?: (value: string) => void | ValidatorMessage;
  isHidden?: boolean;
}

export const InputStructure: FC<InputStructureProps> = ({
  setInputRightPadding,
  error,
  hideErrorMessage = false,
  hideErrorBorder,
  infoMessage,
  children,
  addons,
  withTick,
  styleScheme,
  mode,
  isHidden = false,
}) => {
  const shouldShowError =
    !hideErrorMessage &&
    error != null &&
    error !== '' &&
    (typeof error !== 'object' || isValidElement(error));

  return (
    <ScInputStructure
      hideErrorBorder={hideErrorBorder}
      isHidden={isHidden}
      mode={mode}
      styleScheme={styleScheme}
    >
      <div className="content">
        {children}
        {(addons || withTick) && (
          <div
            className="addons"
            ref={(node) => {
              if (!(node && setInputRightPadding)) return;
              setInputRightPadding(node.clientWidth + 8);
            }}
          >
            {withTick && (
              <div
                className={`icon ${error ? 'error-icon' : 'success-icon'}`}
              />
            )}

            {addons}
          </div>
        )}
      </div>
      {shouldShowError ? (
        <div className="error">{error}</div>
      ) : (
        infoMessage && <div className="info">{infoMessage}</div>
      )}
    </ScInputStructure>
  );
};
